module.exports = __webpack_public_path__ + "static/Felis-D1-1a5160436a476c6a4859e63d1afe3f97.webp";